import { createContext } from "react"
import { User } from "."

/**
 * See discussion in https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
 * In the portal we always wrap the app with the UserProvider, so we don't need undefined in the type.
 * But if someone is trying to access this context without a provider it's ok if we get an error.
 */
export const UserProviderContext = createContext<User>(undefined as any)
